export default __webpack_public_path__ + "static/media/icon-details-link.9508947b.svg";